import type { FontConfig } from 'msp-integrations'

export const getStyles = (font: FontConfig, icon: string) => ({
  Default: `block sticky ${font.regular} font-medium text-center text-white w-full px-1 sm:px-4 md:px-20 lg:px-[240px] py-3 pb-4 z-50 top-0 select-none transform transition duration-500`,

  InfoToggleButton: `flex flex-col sm:flex-row justify-center items-center w-full ${icon}`,

  InfoToggleButtonContent: 'flex items-center mb-1 sm:mb-0',

  InfoToggleTitle: `uppercase ${font.wide} font-medium text-12 tracking-1.2 leading-12`,

  InfoToggleContent: `px-4 sm:px-0 pb-4 pt-6 ${font.regular} text-14 tracking-0.6 leading-20 text-center font-medium select-text`
})
